import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import path from '../../../assets/images/svgImages.svg';
import WasThisHelpfulTwStyles from './WasThisHelpful-tw-styles';
import i18nMessages from '../../../constants/messages/pt-BR';
import { Button } from '../../Generic/Button';
import ALP_Constants from '../../Brand/ArticleListingPage/constants'

const spritePath = typeof path === 'string' ? path : path?.src || '';

const ThumbsUp = props => {
  const { recommendThisArticle, thumbsUp, thumbsDown } = props;
  return (
    <>
      {!thumbsDown && (
        <>
          {!thumbsUp ? (
            <div className={classNames(WasThisHelpfulTwStyles.thumbsUpIconDiv)}>
              <Button
                onClick={() => recommendThisArticle(i18nMessages.thumbsUp)}
                aria-label= {ALP_Constants.GOSTEI_BOTAO}
              >
                <svg
                  className={classNames(
                    WasThisHelpfulTwStyles.thumbsUpStyles,
                    'w-40x h-40'
                  )}
                >
                  <use xlinkHref={`${spritePath}#Thumbs_up`} />
                </svg>
              </Button>
            </div>
          ) : (
            <div
              className={classNames(
                WasThisHelpfulTwStyles.thumbsUpIconDivSelected
              )}
            >
              <Button>
                <svg
                  className={classNames(
                    WasThisHelpfulTwStyles.thumbsUpStylesSelected,
                    'w-15 h-15'
                  )}
                >
                  <use xlinkHref={`${spritePath}#helpfulselected`} />
                </svg>
              </Button>
            </div>
          )}
        </>
      )}
    </>
  );
};
ThumbsUp.propTypes = {
  recommendThisArticle: PropTypes.func.isRequired,
  thumbsUp: PropTypes.string.isRequired,
  thumbsDown: PropTypes.string.isRequired,
};

export default ThumbsUp;
